import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IGeneratePublicKeyParams {
}

export interface IGeneratePublicKeyResult extends IResult {
  key: rsa.IRSAPublicKey;
  keyId: string;
}

export class GeneratePublicKeyRequest extends Request<IGeneratePublicKeyParams, IGeneratePublicKeyResult> {
  constructor(params: IGeneratePublicKeyParams = {}) {
    super('generatePublicKey', params);
  }
}
